import React from 'react';
import { Loader2, Trash2 } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { Action } from './Common';

type Props = {open: boolean; busy: boolean; prefix: string; title: string; description: string;
  cancelLabel: string; confirmLabel: string; onCancel: () => void; onConfirm: () => void};
export const DeleteDialog = ({open, busy, prefix, title, description, cancelLabel, confirmLabel, onCancel, onConfirm}: Props) => <Dialog open={open} onOpenChange={value => {if (!value && !busy) onCancel();}}>
  <DialogContent className="app-dialog" data-testid={`${prefix}-dialog`}>
    <DialogTitle data-testid={`${prefix}-title`}>{title}</DialogTitle>
    <DialogDescription data-testid={`${prefix}-description`}>{description}</DialogDescription>
    <div className="dialog-actions">
      <Action variant="outline" data-testid={`${prefix}-cancel`} disabled={busy} onClick={onCancel}>{cancelLabel}</Action>
      <Action variant="destructive" data-testid={`${prefix}-confirm`} disabled={busy} onClick={onConfirm}>{busy ? <Loader2 className="spin"/> : <Trash2/>}{confirmLabel}</Action>
    </div>
  </DialogContent>
</Dialog>;